<template>
  <v-container fluid>
    <v-layout>
      <v-flex justify-center>
        <material-card
          :height="heightCard"
          elevation-3
          style="background-color: #e1e1e1; overflow: auto"
        >
          <v-layout
            xs12
            sm12
            md12
            justify-center
            fill-height
            column
            class="mb-3"
          >
            <v-card
              v-if="
                exibeTesteGratis &&
                !getAcessoModulo({ user: user, modulo: SALVAR_DIETA }) &&
                !user.testou_premium &&
                ((user.plano !== null && user.plano.id_empresa === null) ||
                  user.plano === null)
              "
            >
              <v-divider />
              <h3 style="color: #273771; text-align: center">
                {{ strings[idioma].experimente_por_7_dias }}:
              </h3>
              <v-divider />
              <v-card>
                <v-container fluid grid-list-md>
                  <v-layout row wrap>
                    <v-flex v-for="plano in planos" :key="plano.id" lg6 xs12>
                      <v-card class="pa-3" outlined>
                        <v-img
                          style="
                            background: #f5f5f5;
                            border-radius: 8px;
                            overflow: hidden;
                          "
                          height="200px"
                        >
                          <div style="padding: 15px; text-align: center">
                            <h2 style="color: #273771; font-weight: 500">
                              {{ plano.titulo[idioma] }}
                            </h2>
                          </div>

                          <div style="text-align: center">
                            <v-btn
                              color="primary"
                              @click="sejaPremium(plano)"
                              style="
                                margin-top: 5px;
                                color: white;
                                font-weight: bold;
                              "
                            >
                              {{ strings[idioma].experimente_gratis }}
                            </v-btn>
                          </div>
                        </v-img>
                      </v-card>
                      <v-dialog v-model="dialog" max-width="400">
                        <v-card>
                          <v-card-title
                            style="color: #273771; font-weight: 500"
                          >
                            Confirmação
                          </v-card-title>
                          <v-card-text style="color: #273771; font-weight: 400">
                            Deseja realmente ativar seu período de testes do {{ planoDescricao }} por 7 dias?
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" text @click="dialog = false">
                              Não
                            </v-btn>
                            <v-btn color="primary" text @click="ativarTeste()">
                              Sim
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-card>

            <v-card v-else class="mb-4">
              <h3
                class="text-center"
                style="color: #273771; text-align: center"
              >
                Você já teve um plano ativo em sua conta, entre em contato para
                obter mais informações:
              </h3>
              <div style="text-align: center">
                <v-btn color="primary">
                  <a
                    style="margin-top: 5px; color: white; font-weight: bold"
                    href="https://api.whatsapp.com/send?phone=5537999820856&text=Olá, vocês podem me ajudar?"
                    class="btn btn-success me-2"
                    >Whatsapp: (37) 99982-0856</a
                  >
                </v-btn>
                <v-btn color="primary"
                  ><a
                    style="margin-top: 5px; color: white; font-weight: bold"
                    href="mailto:contato@brcorte.com.br"
                    class="btn btn-info"
                    >E-Mail: contato@brcorte.com.br</a
                  ></v-btn
                >
              </div>
              <p
                class="text-center"
                style="font-size: 14px; color: #666; text-align: center"
              >
                * Horário de atendimento: Segunda a Sexta, 08 às 18 hrs (Horário
                de Brasília)
              </p>
            </v-card>
          </v-layout>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { SALVAR_DIETA } from "@/utils/types";
export default {
  data() {
    return {
      loading: true,
      error: null,
      alreadyUsed: false,
      SALVAR_DIETA: SALVAR_DIETA,
      planos: [
        {
          id: 1,
          titulo: ["Plano START", "Plan START", "Plan START"],
        },
        {
          id: 2,
          titulo: ["Plano CONSULTOR", "Plan CONSULTANT ", "Plan CONSULTOR"],
        },
      ],
      dialog: false,
      planoDescricao:'',
    };
  },
  computed: {
    ...mapState("app", [
      "data",
      "acesso_premium",
      "strings",
      "idioma",
      "user",
      "exibeTesteGratis",
    ]),
    heightCard() {
      return String(this.$vuetify.breakpoint.height - 100) + "px";
    },
  },
  async created() {},
  methods: {
    sejaPremium(plano) {
      this.dialog = true;
      this.planoDescricao = plano.titulo[this.idioma];
    },

    ativarTeste() { 
      this.dialog = false;
      let planoId = this.planoDescricao === "Plano START" ? 1 : 2;

      this.axios.post("user/testarPremium",{ tipo: planoId }).then((r) => {
        setTimeout(() => {
          window.location.href = "/";
        }, 1000);
        this.sweetAlert(
          this.strings[this.idioma].experimente_gratis_7_dias_confirmar
        );
      });
    },

   
  },
};
</script>
